import { MenuItemCategory, MenuItemType, NavObjectType, jsxParams } from "../Components/navigationTypes";
import { AddMenu } from './addMenu';
import { MenuItem } from "./menuItem";
import Alert from 'react-bootstrap/Alert';
import ListGroup from 'react-bootstrap/ListGroup';
import { IndicatorBadgeType } from "./sideTypes";
import { runInnerFunction } from "../compatManager";
import { useContext } from "react";
import { NavigationContext } from "../Context/NavigationContext";
import React from "react";
import { useAppSelector } from "../redux/hooks";
import { lddStateObject } from "../redux/reducer";

export function navItem(menuState: Record<string, boolean>, toggleMenuState: (element: string) => () => void, numOfTabs: number, page?: NavObjectType) {
    return (item: MenuItemType, navItemIndex: number) =>
        <NavigationElement
            key={item.label + item.type + navItemIndex}
            item={item}
            menuState={menuState}
            toggleMenuState={toggleMenuState}
            numOfTabs={numOfTabs}
            navItemIndex={navItemIndex}
            page={page}
        />
}

const TOGGLE_THRESHOLD = 3;

const MoreLessToggle = (props: {
    size: number,
    less: boolean,
    toggleMenuState: ((menuState:string) =>React.MouseEventHandler<HTMLElement>),
    label: string,
    expandable: boolean,
    maxSize: number,
}) => {
    return (
        <i onClick={props.toggleMenuState(props.label)} className={props.less ? 'fa-duotone fa-circle-chevron-up' : 'fa-duotone fa-circle-chevron-down'}></i>
    )
}

const NavAlert = (props: {
    variant: string,
    text?: string,
    jsx?: jsxParams["jsx"]
}) => {
    return (
        <>
            {props.text &&
                <Alert variant={props.variant}>
                    {props.text}
                </Alert>
            }
            {props.jsx &&
                <Alert variant={props.variant}>
                    {props.jsx.map(({ tag, text }, index) => {
                        return React.createElement(tag, { key: `alert-${index}` }, text)
                    })}
                </Alert>
            }
        </>
    )
}

const HeaderAdd = (props: {
    menu: Array<MenuItemType>,
    link: NavObjectType,
    newIndex: string,
    iconType?: "ellipsis" | "default",
}) => {
    const nav = useContext(NavigationContext);
    const sessionInfo = useAppSelector((state: lddStateObject) => state.SessionInfo);
    if (props.menu.length > 0) {
        return (<AddMenu menuOptions={props.menu} nav={nav} SessionInfo={sessionInfo} iconType={props.iconType} />)
    }
    if (props.link.component === "main" && props.link.url && props.link.params) {
        props.link.params.tabNum = String(props.newIndex);
        return (
            <i className="fa-solid fa-circle-plus" onClick={() => {
                if (props.link.action > "") {
                    window.setTimeout(function () {
                        runInnerFunction(props.link.action, null);
                    }, 100)
                }
                nav(props.link)
            }} />
        )
    }
    return <></>
}
// Build Side bar out of json prop
const NavigationElement = (props: {
    item: MenuItemType,
    menuState: Record<string, boolean>
    numOfTabs: number,
    toggleMenuState: (element: string) => () => void,
    navItemIndex: number,
    page?: NavObjectType
}) => {
    const nav = useContext(NavigationContext)
    const threshold = props.item.maxSize ? props.item.maxSize : TOGGLE_THRESHOLD;
    const indicatorBadges: Array<IndicatorBadgeType> = [];
    switch (props.item.type) {
        case MenuItemCategory.Heading:
            let subItemList = props.item.subItems ? props.item.subItems : [];
            const size = subItemList.length;
            if (!props.menuState[props.item.label] && props.item.expandable) {
                subItemList = subItemList.slice(0, threshold);
            }
            const subItemElementList = subItemList.map(navItem(props.menuState, props.toggleMenuState, subItemList.length, props.page));
            return (
                <>
                    <ListGroup.Item className="nav-header">
                        <h4 className="me-auto">
                            {props.item.label} 
                            {(props.item.expandable && props.item.id !== "Issues" && size > threshold ? <span style={{fontSize:'12px', marginLeft:'3px'}}>({subItemList.length}/{size})</span> : "")}
                        </h4>

                        {(!(size <= threshold || !props.item.expandable)) &&
                            <MoreLessToggle
                                maxSize={threshold}
                                expandable={props.item.expandable}
                                size={size}
                                label={props.item.label}
                                less={props.menuState[props.item.label]}
                                toggleMenuState={props.toggleMenuState} />
                        }
                        <HeaderAdd newIndex={String(size + 1)} menu={props.item.addOptions} link={props.item.navigate}  iconType={props.item.addOptionsType} />
                    </ListGroup.Item>

                    {subItemElementList}
                </>
            )
        case MenuItemCategory.Blank:
            let elmts = props.item.subItems ? props.item.subItems : [];
            let elmtList = elmts.map(navItem(props.menuState, props.toggleMenuState, elmts.length));
            return (
                <>
                    {elmtList}
                </>
            )
        case MenuItemCategory.Alert:
            return (
                <>
                    <div className="nav-header">
                        <h4>{props.item.label}</h4>
                    </div>

                    <NavAlert
                        variant={props.item.params?.variant}
                        text={props.item.params?.text ?? null}
                        jsx={props.item.jsxParams?.jsx ?? null}
                    />

                </>
            )
        case MenuItemCategory.Person:
            return (
                <MenuItem
                    nav={nav}
                    menuType={props.item.type}
                    numOfTabs={props.numOfTabs}
                    agreement={props.item.params?.agreement === "1"}
                    title={props.item.params?.title === "1"}
                    label={props.item.label}
                    final={props.item.params?.final && props.item.params.final === "true"}
                    link={props.item.navigate}
                    buyer={props.item.params}
                    subIndex={props.item.type + props.navItemIndex}
                />
            )
        case MenuItemCategory.Matter:
            let type;
            switch (props.item.params.matterType) {
                case 'All':
                    type = 'info';
                    break;
                case 'Resolved':
                    type = 'success';
                    break;
                case 'Outstanding':
                    type = 'warning';
                    break;
                default:
                    type = 'inactive'
                    break;
            }
            indicatorBadges.push({
                type: type,
                label: props.item.params['counter'],
                category: props.item.params?.badgeCategory
            })
            break;
        default:
            if (props.item.params?.badgetext !== undefined) {
                indicatorBadges.push({
                    type: props.item.params?.badgetype ? props.item.params?.badgetype : 'inactive',
                    label: props.item.params?.badgetext,
                    category: props.item.params?.badgeCategory
                })
            }
            break;
    }
    return (
        <MenuItem
            nav={nav}
            menuType={props.item.type}
            key={props.item.label + props.navItemIndex}
            link={props.item.navigate}
            label={props.item.label}
            final={props.item.params?.final && props.item.params.final === "true"}
            indicatorList={indicatorBadges}
            numOfTabs={props.numOfTabs}
            subIndex={props.item.type + props.navItemIndex}
            dropdownOptions={props.item.dropdownOptions || []}
            requiredFields={props.item.requiredFields || []}
            symbol={props.item.symbol || null}
            page={props.page}
        />)
}